import React from "react";
import * as styles from "./style.module.css";

const Shimmer = ({ width, height }) => {
  return (
    <div
      className={styles.shimmerWrapper}
      style={{ width, height }}
    >
      <div className={styles.shimmer}></div>
    </div>
  );
};

export default Shimmer;
